import styled from 'styled-components';

export const MainHeaderContainer = styled.div`
    // padding: 2%;
    max-width: 100vw;
    height: 350px;
    min-height: 70vh;
    margin: 0 0 2% 0;
    display: flex;
    justify-content: center;

    .main-header-box {
        background-color: rgba(0,0,0,0.5);
        border-radius: 1.5px;
        box-shadow: white 0 0 5px;
        width: 98%; 
        height: 100%;
        align-self: center;
        display: flex;
        flex-direction:  ${window.screen.width <= 1000 ? 'column' : 'row'}; 
    }

    
    .main-text {
        color: white;
        width: ${window.screen.width <= 1000 ? '100%' : '50%'}; 
        // max-width: 100%;
        height: ${window.screen.width <= 1000 ? '50%' : '100%'}; 
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h2 {
        //    text-shadow: black 0 0 3px;
           font-size: ${window.screen.width <= 1000 ? '1.5em' : '3.5em'};
           line-height: 165%;
           padding: 0;
           margin: 0;
           width: 90%;
        }
        
        p {
           font-size: ${window.screen.width <= 1000 ? '20px' : '30px'}; 
        }


        .search-box {
            // background-color: red;
            // font-size: 25px
            width: 560px;
            max-width: 85%;
            // height: 20%;
            // padding: 5%;
            // display: flex;
            // flex-direction: column;
            // align-items: flex-start;
            // justify-content: flex-start;
        }
    }

    .main-visual {
        // background-color: red;
        width: ${window.screen.width <= 1000 ? '100%' : '50%'}; 
        // max-width: 100%;
        height: ${window.screen.width <= 1000 ? '50%' : '100%'};
        background-repeat: no-repeat;
        background-position: center top 40%;
        background-size: cover;
    }
`;